import { IAppAction, ActionType } from "../actions/Helpers";

export interface ISnackbarState {
  open: boolean;
  closeDelay: number | null;
  onClose?: (event: any, reason: string) => void;
  variant: "success" | "warning" | "error" | "info";
  message: any | null;
  actionURL?: string | null;
  actionType?: "external-link" | null; // Add more here as they are required.
  actionLabel?: string | null;
}

const handleClose = (event: any, reason: string): void => {
  if (reason === "clickaway") {
    return;
  }
};

const defaultState: ISnackbarState = {
  open: false,
  closeDelay: 0,
  onClose: handleClose,
  variant: "info",
  message: null,
  actionURL: null,
  actionType: null,
  actionLabel: null,
};

export const SnackbarReducer = (state = defaultState, action: IAppAction): ISnackbarState => {
  switch (action.type) {
    case ActionType.OPEN_SNACKBAR:
      return { ...state, ...{ ...defaultState, ...action.payload } };
    case ActionType.CLOSE_SNACKBAR:
      return {
        ...state,
        open: false,
        closeDelay: 0,
        onClose: handleClose,
        variant: "info",
        message: null,
        actionURL: null,
        actionType: null,
        actionLabel: null,
      };
    default:
      return state;
  }
};
